// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","bestsellerHeading":"search_bestsellerHeading__lWEYK","searchRecommendationLoadingClass":"search_searchRecommendationLoadingClass__urhAX"};